import { Epic } from '@/types';
import { createAsyncSingleLoadingEpic } from '@ro-loading';
import { createAsyncEpic, ofAction, ofActions } from '@tsfsa-ro';
import * as R from 'ramda';
import { combineEpics } from 'redux-observable';
import { filter, map } from 'rxjs';
import {
  createModAction,
  feedModAction,
  getByIdModAction,
  removeByIdModAction,
  sortedFeedModAction,
  updateModAction,
  updateSortedModAction,
} from './mod.action';
import { ModCreatePayload, ModEntity, ModType, ModUpdatePayload } from './mod.types';
import { Success } from 'typescript-fsa';

const propId = R.map(R.prop('id'));

const feedModEpic = createAsyncEpic(feedModAction, ({ modApi }) => modApi.feed.bind(modApi));
const sortedFeedModEpic = createAsyncEpic(
  sortedFeedModAction,
  ({ modApi }) =>
    () =>
      modApi.sortedFeed().pipe(
        map((data) => {
          return {
            record: R.indexBy(R.prop('id'), [
              ...data[ModType.SKIN],
              ...data[ModType.MOD],
              ...data[ModType.SEED],
              ...data[ModType.MAP],
            ]),
            sortedIds: {
              [ModType.MOD]: propId(data[ModType.MOD]),
              [ModType.SKIN]: propId(data[ModType.SKIN]),
              [ModType.SEED]: propId(data[ModType.SEED]),
              [ModType.MAP]: propId(data[ModType.MAP]),
            },
          };
        }),
      ),
);
const createModEpic = createAsyncEpic(createModAction, ({ modApi }) => modApi.create.bind(modApi));
const updateModEpic = createAsyncEpic(updateModAction, ({ modApi }) => modApi.update.bind(modApi));
const updateSortedModEpic = createAsyncEpic(updateSortedModAction, ({ modApi }) => modApi.updateSorted.bind(modApi));
const getByIdModEpic = createAsyncEpic(getByIdModAction, ({ modApi }) => modApi.getById.bind(modApi));
const removeByIdModEpic = createAsyncEpic(removeByIdModAction, ({ modApi }) => modApi.removeById.bind(modApi));

const navigateToMoListAfterCreateEpic: Epic = (action$, _, { history }) =>
  action$.pipe(
    ofActions(createModAction.done, updateModAction.done),
    filter(({ result }) => {
      history.replace(`/mod/${result.type}`);
      return false;
    }),
  );

const feedModLoadingEpic = createAsyncSingleLoadingEpic(feedModAction, 'feedMod');
const sortedFeedModLoadingEpic = createAsyncSingleLoadingEpic(sortedFeedModAction, 'feedSortedMod');
const createModLoadingEpic = createAsyncSingleLoadingEpic(createModAction, 'createMod');
const getByIdModLoadingEpic = createAsyncSingleLoadingEpic(getByIdModAction, 'getByIdMod');

export const modEpic = combineEpics(
  feedModEpic,
  sortedFeedModEpic,
  createModEpic,
  updateModEpic,
  updateSortedModEpic,
  getByIdModEpic,
  removeByIdModEpic,

  navigateToMoListAfterCreateEpic,

  feedModLoadingEpic,
  sortedFeedModLoadingEpic,
  createModLoadingEpic,
  getByIdModLoadingEpic,
);
